import { DeleteButton } from "../../../../../../../common/Components/Buttons/DeleteButton";
import { AppIconButton } from "../../../../../../../shared/components/AppIconButton";
import { EditIcon } from "../../../../../../../shared/icons/EditIcon";
import { PlusIcon } from "../../../../../../../shared/icons/PlusIcon";
import { TSpeechActions } from "../../../../../types";
import styles from "./styles.module.css";

interface Props {
  speechItemId: string;
  handleAction: (id: string, type: TSpeechActions) => void;
  handleEditMode: () => void;
  className?: string;
}

export const TranscriptActions = ({
  speechItemId,
  handleAction,
  handleEditMode,
  className,
}: Props) => {
  return (
    <div className={styles["actions-container"]}>
      <AppIconButton onClick={() => handleAction(speechItemId, "add")}>
        <PlusIcon />
      </AppIconButton>
      <AppIconButton onClick={handleEditMode}>
        <EditIcon />
      </AppIconButton>
      <DeleteButton
        entityId={speechItemId}
        onDelete={() => handleAction(speechItemId, "delete")}
      />
    </div>
  );
};
